// startup
// Load entry module and return exports
// This entry module is referenced by other modules so it can't be inlined
__webpack_require__("./src/client/app/polyfills.ts");
var __webpack_exports__ = __webpack_require__("./src/client/app/tgccmain.tsx");
